var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoginLoading = function SvgLoginLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.955,
    cy: 7.955,
    r: 7,
    stroke: "#D4D7DB",
    strokeWidth: 1.909
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#06C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.909,
    d: "M.955 7.955a7 7 0 1 0 7-7"
  })));
};
export default SvgLoginLoading;